/*!
 * devextreme-vue
 * Version: 22.1.5
 * Build date: Fri Sep 02 2022
 *
 * Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-vue
 */

"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DxValidationGroup = void 0;
var validation_group_1 = __importDefault(require("devextreme/ui/validation_group"));
var index_1 = require("./core/index");
var DxValidationGroup = index_1.createComponent({
    props: {
        elementAttr: Object,
        height: [Function, Number, String],
        onDisposing: Function,
        onInitialized: Function,
        onOptionChanged: Function,
        width: [Function, Number, String]
    },
    emits: {
        "update:isActive": null,
        "update:hoveredElement": null,
        "update:elementAttr": null,
        "update:height": null,
        "update:onDisposing": null,
        "update:onInitialized": null,
        "update:onOptionChanged": null,
        "update:width": null,
    },
    computed: {
        instance: function () {
            return this.$_instance;
        }
    },
    beforeCreate: function () {
        this.$_WidgetClass = validation_group_1.default;
        this.$_hasAsyncTemplate = true;
    }
});
exports.DxValidationGroup = DxValidationGroup;
exports.default = DxValidationGroup;
